
const TemplateTen = () => {
    return (
      <div className="slideshow">
        <figure>
          {/* Project Details Starts */}
          <figcaption>
            <h3>Shopify E-Commerce</h3>
            <div className="row open-sans-font">
              <div className="col-12 mb-2">
              <i class="fab fa-shopify"></i>
                <span className="ft-wt-600 uppercase"> Gorgeous Shopify Fashion Theme created for clothing, jewelry, cosmetics, accessories, and fashion apparel Shop. Easily stay connected with your clients using advanced social integration. </span>
              </div>
            </div>
            {/* End .row */}
          </figcaption>
          {/* Project Details Ends */}
  
          {/*  Main Project Content Starts */}
          <img src="img/projects/templates/10.jpg" alt="Portolio" />
          {/* Main Project Content Ends */}
        </figure>
      </div>
      //  End .slideshow
    );
  };
  
  export default TemplateTen;
  